export default __webpack_public_path__ + "static/media/led1c.22eb9d2d.png";